"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var query_string_1 = require("query-string");

var react_admin_1 = require("react-admin");
/**
 * Maps react-admin queries to a simple REST API
 *
 * The REST dialect is similar to the one of FakeRest
 * @see https://github.com/marmelab/FakeRest
 * @example
 * GET_LIST     => GET http://my.api.url/posts?sort=['title','ASC']&range=[0, 24]
 * GET_ONE      => GET http://my.api.url/posts/123
 * GET_MANY     => GET http://my.api.url/posts?filter={ids:[123,456,789]}
 * UPDATE       => PUT http://my.api.url/posts/123
 * CREATE       => POST http://my.api.url/posts
 * DELETE       => DELETE http://my.api.url/posts/123
 */


exports.default = function (apiUrl, httpClient) {
  if (httpClient === void 0) {
    httpClient = react_admin_1.fetchUtils.fetchJson;
  }
  /**
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The data request params, depending on the type
   * @returns {Object} { url, options } The HTTP request parameters
   */


  var convertDataRequestToHTTP = function convertDataRequestToHTTP(type, resource, params) {
    var _a;

    var url = '';
    var options = {};
    var token = sessionStorage.getItem('token');

    switch (type) {
      case react_admin_1.GET_LIST:
        {
          switch (resource) {
            case 'Templates':
            case 'ActiveCampaigns':
              url = apiUrl + '/Get' + resource + '?token=' + token;
              break;

            case 'ScheduledCampaigns':
              url = apiUrl + '/Get' + resource + '?type=pending';
              break;

            case 'Profile':
              url = apiUrl + '/GetSession?token=' + token;
              break;

            case 'Softphone':
              url = apiUrl + '/GetIncomingCalls?token=' + token;
              break;

            case 'products':
            case 'orders':
            case 'reviews':
            case 'customers':
            case 'categories':
            case 'invoices':
            case 'EshopSettings':
              if (resource == 'invoices') resource = 'orders';
              url = apiUrl + '/GetTextFiles?token=' + token + 'ext=.json&path=ivr2:eshop/' + resource;
              break;

            case 'IVR':
              if (params.filter.path == undefined) url = apiUrl + '/GetIVR2Dir?token=' + token + '&path=ivr2:/';else {
                if (params.filter.path.lastIndexOf('.') > 0) {
                  var path = params.filter.path.substr(0, params.filter.path.lastIndexOf("/") + 1);
                  url = apiUrl + '/GetIVR2Dir?token=' + token + '&path=' + path;
                } else {
                  path = params.filter.path;
                  url = apiUrl + '/GetIVR2Dir?token=' + token + '&path=' + path;
                }
              }
              break;
          }

          break;
        }

      case react_admin_1.GET_ONE:
        {
          url = apiUrl + "/" + resource + "/" + params.id;

          switch (resource) {
            case 'Templates':
              url = apiUrl + '/GetTemplates?token=' + token;
              break;

            case 'Profile':
              url = apiUrl + '/GetSession?token=' + token;
              break;

            case 'GetTextFile':
            case 'GetFiles':
              url = apiUrl + '/GetTextFile?token=' + token + '&what=' + params.id;
              break;

            case 'products':
            case 'orders':
            case 'reviews':
            case 'customers':
            case 'categories':
            case 'invoices':
            case 'EshopSettings':
              if (resource == 'invoices') resource = 'orders';
              url = apiUrl + '/GetTextFiles?token=' + token + '&ext=.json&path=ivr2:eshop/' + resource;
              break;
          }

          break;
        }

      case react_admin_1.GET_MANY:
        {
          switch (resource) {
            case 'Templates':
              // url = apiUrl + '/GetCampaignStatus?' + params.id;
              break;

            case 'Profile':
              url = apiUrl + '/GetSession';
              break;

            case 'products':
            case 'orders':
            case 'reviews':
            case 'customers':
            case 'categories':
            case 'invoices':
            case 'EshopSettings':
              if (resource == 'invoices') resource = 'orders';
              url = apiUrl + '/GetTextFiles?token=' + token + '&ext=.json&path=ivr2:eshop/' + resource;
              break;

            case 'GetFiles':
              url = apiUrl + '/GetTextFile?token=' + token + '&what=' + params.ids[0];
              break;

            case 'OpenIniFiles':
              url = apiUrl + '/GetTextFile?token=' + token + '&what=' + params.id;
              break;
          }

          break;
        }

      case react_admin_1.GET_MANY_REFERENCE:
        {
          switch (resource) {
            case 'GetTemplateEntries':
              url = apiUrl + '/' + resource + '?token=' + token + '&templateId=' + params.id;
              break;

            case 'GetFiles':
              var tree = JSON.parse(sessionStorage.getItem('Xtree'));
              var path = tree.find(function (x) {
                return x.id === params.id;
              }).what;
              url = apiUrl + '/' + resource + '?token=' + token + '&path=' + path;
              break;

            case 'GetTextFile':
              url = apiUrl + '/' + resource + '?token=' + token + '&what=' + params.id + '/ext.ini';
              break;

            case 'products':
            case 'orders':
            case 'reviews':
            case 'customers':
            case 'categories':
            case 'invoices':
              if (resource == 'invoices') resource = 'orders';
              url = apiUrl + '/GetTextFiles?token=' + token + '&ext=.json&path=ivr2:eshop/' + resource;
              break;

            case 'OpenIniFiles':
              url = apiUrl + '/GetTextFile?token=' + token + '&what=' + params.id;
              break;
          }

          break;
        }

      case react_admin_1.UPDATE:
        {
          switch (resource) {
            case 'ActiveCampaigns':
              url = apiUrl + '/CampaignAction' + '?token=' + token + '&campaignId=' + params.id + '&action=' + params.data.action + '&value=' + params.data.value;
              options.method = 'GET';
              break;

            case 'GetTemplateEntries':
              url = apiUrl + '/UpdateTemplateEntry' + '?token=' + token + '&templateId=' + params.data.templateId + '&rowid=' + params.data.rowid + '&phone=' + params.data.phone + '&name=' + params.data.name + '&moreinfo=' + params.data.moreinfo + '&blocked=' + Number(params.data.blocked);
              options.method = 'GET';
              break;

            case 'Templates':
              // delete params.data.callerId;
              var paramsJson = JSON.stringify(params.data);
              var paramsString = paramsJson.replace(/\:/g, "=").replace(/\,/g, "&").replace(/ /g, "%20").replace(/{/g, "").replace(/}/g, "").replace(/"/g, "").replace(/true/g, "1").replace(/false/g, "0");
              url = apiUrl + '/UpdateTemplate?' + paramsString;
              options.method = 'GET';
              break;

            case 'Profile':
              var profileJson = JSON.stringify(params.data);
              var profileString = profileJson.replace(/\:/g, "=").replace(/\,/g, "&").replace(/ /g, "%20").replace(/{/g, "").replace(/}/g, "").replace(/"/g, "").replace(/true/g, "1").replace(/false/g, "0");
              url = apiUrl + '/SetCustomerDetails?' + profileString;
              options.method = 'GET'; // url = apiUrl + '/SetCustomerDetails'
              // options.body = JSON.stringify(params.data);
              // options.method='POST';

              break;

            case 'products':
              var contents = JSON.stringify(params.data);
              url = apiUrl + '/UploadTextFile?what=ivr2:eshop/products/' + params.data.reference + '.json&contents=' + contents;
              options.method = 'GET';
              break;

            case 'customers':
            case 'categories':
            case 'orders':
            case 'reviews':
            case 'invoices':
            case 'EshopSettings':
              if (resource == 'invoices') resource = 'orders';
              var contents = JSON.stringify(params.data);
              url = apiUrl + '/UploadTextFile?token=' + token + '&what=ivr2:eshop/' + resource + '/' + params.data.id + '.json&contents=' + contents;
              options.method = 'GET';
              break;
            // case 'IVR':
            //         var tree = JSON.parse(sessionStorage.getItem('Xtree'));
            //         const regex = /[^\/]+$/g;
            //         if (params.data.parent_id==params.previousData.parent_id) var moveTo = params.data.what.replace(regex, "/"+params.data.name);
            //         else var moveTo = tree.find(x => x.id === params.data.parent_id).what
            //         url = apiUrl + '/FileAction?action=move&what='+params.previousData.what+'&target=' + moveTo;
            //         options.method='GET';
            //         sessionStorage.setItem('Xtree','');
            // break;

            default:
              url = apiUrl + '/' + resource + '/' + params.id;
              options.method = 'PUT';
              options.body = JSON.stringify(params.data);
              break;
          }

          break;
        }

      case react_admin_1.CREATE:
        {
          switch (resource) {
            case 'products':
              var contents = JSON.stringify(params.data);
              url = apiUrl + '/UploadTextFile?token=' + token + '&what=ivr2:eshop/products/' + params.data.reference + '.json&contents=' + contents;
              options.method = 'GET';
              break;

            case 'GetTemplateEntries':
              if (params.data.blocked === undefined) params.data.blocked = 0;
              url = apiUrl + '/UpdateTemplateEntry?token=' + token + '&templateId=' + params.data.templateId + '&phone=' + params.data.phone + '&name=' + params.data.name + '&moreinfo=' + params.data.moreinfo + '&blocked=' + params.data.blocked;
              options.method = 'GET';
              console.log('GetTemplateEntriesGetTemplateEntriesGetTemplateEntries');
              console.log(url); // url = apiUrl + "/UpdateTemplateEntry?token="+token ;
              // options.method = 'POST';
              // options.body = JSON.stringify(params.data);

              break;

            case 'customers':
            case 'reviews':
            case 'invoices':
            case 'orders':
              if (resource == 'invoices') resource = 'orders';
              var contents = JSON.stringify(params.data);
              url = apiUrl + '/UploadTextFile?token=' + token + '&what=ivr2:eshop/' + resource + '/' + params.data.id + '.json&contents=' + contents;
              options.method = 'GET';
              break;

            default:
              url = apiUrl + "/" + resource;
              options.method = 'POST';
              options.body = JSON.stringify(params);
          }

          break;
        }

      case react_admin_1.DELETE:
        {
          url = apiUrl + "/" + resource + "/" + params.id; // options.method = 'DELETE';

          switch (resource) {
            case 'ScheduledCampaigns':
              url = apiUrl + '/DeleteScheduledCampaign?token=' + token + '&schedId=' + params.id;
              options.method = 'GET';
              break;

            case 'Templates':
              url = apiUrl + '/DeleteTemplate?token=' + token + '&templateId=' + params.id;
              options.method = 'GET';
              break;

            case 'products':
              url = apiUrl + '/FileAction?token=' + token + '&what=ivr2:eshop/products/' + params.previousData.reference + '.json&action=delete';
              options.method = 'GET';
              break;

            case 'orders':
            case 'customers':
            case 'categories':
            case 'reviews':
            case 'invoices':
              if (resource == 'invoices') resource = 'orders';
              url = apiUrl + '/FileAction?token=' + token + '&what=ivr2:eshop/' + resource + '/' + params.id + '.json&action=delete';
              options.method = 'GET';
              break;

            case 'IVR':
              url = apiUrl + '/FileAction?token=' + token + '&action=delete&what=' + params.previousData.what;
              options.method = 'GET'; // var XtreeArray = JSON.parse(sessionStorage.Xtree);
              // const newXtree = XtreeArray.filter((el) => {
              //     return el.what !== params.previousData.what;
              // });
              // sessionStorage.setItem('Xtree',JSON.stringify(newXtree));

              break;
          }

          break;
        }

      default:
        throw new Error("Unsupported fetch action type " + type);
    }

    return {
      url: url,
      options: options
    };
  };
  /**
   * @param {Object} response HTTP response from fetch()
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The data request params, depending on the type
   * @returns {Object} Data response
   */


  var convertHTTPResponse = function convertHTTPResponse(response, type, resource, params) {
    var headers = response.headers,
        json = response.json;
    var token = sessionStorage.getItem('token');

    switch (type) {
      case react_admin_1.GET_LIST:
        if (resource == 'Softphone') {
          var countTotal = json['calls'].length;
          json['data'] = json['calls'];

          for (var i = 0; i < countTotal; i++) {
            json['data'][i]['callId'] = json['data'][i]['id'];
            json['data'][i]['id'] = i;
          }

          if (countTotal == 0) {
            json['data'].push([]);
            json['data'][0]['callId'] = 'No Calls';
            json['data'][0]['id'] = 0;
            countTotal = 1;
          }

          return {
            data: json['data'],
            total: countTotal //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        }

      case react_admin_1.GET_MANY:
        if (resource == 'OpenIniFiles') {
          var jsondata = [];
          jsondata.contents = json.contents;
          jsondata.id = 0;
          return {
            data: jsondata
          };
        }

      case react_admin_1.GET_MANY_REFERENCE:
        if (resource == 'Templates') {
          var countTotal = json['templates'].length;

          for (var _i = 0; _i < countTotal; _i++) {
            json['templates'][_i]['id'] = json['templates'][_i]['templateId'];
          }

          return {
            data: json['templates'],
            total: countTotal //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (resource == 'products' || resource == 'categories' || resource == 'customers' || resource == 'orders' || resource == 'reviews' || resource == 'invoices' || resource == 'EshopSettings') {
          var list = [];
          json.files.forEach(function (element) {
            list.push(element.contents);
          });

          try {
            if ('category_id' in params.filter) var list = list.filter(function (name) {
              return name.includes('"category_id":' + params.filter.category_id);
            });
          } catch (_unused) {}

          try {
            if ('q' in params.filter) var list = list.filter(function (name) {
              return name.includes('"name":"' + params.filter.q);
            });
          } catch (_unused2) {}

          try {
            if ('ids' in params && resource == 'customers') var list = list.filter(function (name) {
              return name.includes('"id":"' + params.ids[0]);
            });
          } catch (_unused3) {}

          try {
            if ('ids' in params && resource == 'products') {
              var IDlist = [];
              params.ids.forEach(function (id) {
                IDlist.push(list.filter(function (name) {
                  return name.includes('"reference":"' + id);
                })[0]);
              });
              list = IDlist;
            }
          } catch (_unused4) {}

          try {
            if ('ids' in params) {
              var IDlist = [];
              params.ids.forEach(function (id) {
                IDlist.push(list.filter(function (name) {
                  return name.includes('"id":"' + id);
                }));
              });
            }
          } catch (_unused5) {}

          var countTotal = list.length;
          var items = [];

          for (var _i2 = 0; _i2 < countTotal; _i2++) {
            items[_i2] = JSON.parse(list[_i2]);
            if (resource == 'products') items[_i2]['id'] = items[_i2]['reference'];
          }

          return {
            data: items,
            total: countTotal //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (resource == 'IVR') {
          json['data'] = json['dirs'].concat(json['ini']).concat(json['files']).concat(json['html']);
          var countTotal = json['data'].length;

          for (var _i3 = 0; _i3 < countTotal; _i3++) {
            json['data'][_i3]['callId'] = json['data'][_i3]['id'];
            json['data'][_i3]['id'] = _i3;
          }

          var allFiles = '';
          json['data'].forEach(function (element) {
            allFiles += element.what + ',';
          });
          var allDirs = ',';
          if (sessionStorage.getItem('AllDirs')) allDirs = sessionStorage.getItem('AllDirs');
          json['dirs'].forEach(function (element) {
            var dir = element.what.replace('ivr2:/', '').replace('ivr2:', '');
            if (!allDirs.includes(',' + dir + ',')) allDirs += dir + ',';
          });
          sessionStorage.setItem('AllFiles', allFiles);
          sessionStorage.setItem('AllDirs', allDirs);
          sessionStorage.setItem('Messages', JSON.stringify(json['messages']));
          sessionStorage.setItem('Filter', JSON.stringify(params.filter));
          return {
            data: json['data'],
            total: countTotal,
            //parseInt(headers.get('content-range').split('/').pop(), 10)
            type: params.filter.type
          };
        } else if (resource == 'Profile') {
          json.id = 1;
          var datajson = [json];
          return {
            data: datajson,
            total: 1 //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (resource == 'GetTextFile' || resource == 'OpenIniFiles') {
          json.id = 1;
          var _datajson = [json];
          return {
            data: _datajson,
            total: 10 //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (resource == 'Softphone') {
          var countTotal = json['calls'].length;
          json['data'] = json['calls'];

          for (var _i4 = 0; _i4 < countTotal; _i4++) {
            json['data'][_i4]['callId'] = json['data'][_i4]['id'];
            json['data'][_i4]['id'] = _i4;
          }

          if (countTotal == 0) {
            json['data'][0]['callId'] = 'No Calls';
            json['data'][0]['id'] = 0;
          }

          return {
            data: json['data'],
            total: countTotal //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (resource == 'GetFiles') {
          var countTotal = json['files'].length;
          json['data'] = json['files'];

          for (var _i5 = 0; _i5 < countTotal; _i5++) {
            json['data'][_i5]['id'] = json['data'][_i5]['what'];
          }

          return {
            data: json['data'],
            total: countTotal //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (resource == 'GetTemplateEntries') {
          var countTotal = json['entries'].length;
          sessionStorage.setItem('allEntries', '');
          json['data'] = json['entries'];

          for (var _i6 = 0; _i6 < countTotal; _i6++) {
            json['data'][_i6]['id'] = json['data'][_i6]['rowid'];
            sessionStorage.setItem('allEntries', sessionStorage.allEntries + json['data'][_i6]['rowid'] + '-');
            json['data'][_i6]['templateId'] = json['templateId'];
          }

          return {
            data: json['data'],
            total: countTotal //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (resource == 'ActiveCampaigns') {
          var countTotal = json['campaigns'].length;
          json['data'] = json['campaigns'];

          for (var _i7 = 0; _i7 < countTotal; _i7++) {
            json['data'][_i7]['id'] = json['data'][_i7]['campaignId'];
            json['data'][_i7]['templateId'] = json['templateId'];
          }

          return {
            data: json['data'],
            total: countTotal //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (resource == 'ScheduledCampaigns') {
          var countTotal = json['scheduledCampaigns'].length;
          json['data'] = json['scheduledCampaigns'];

          for (var _i8 = 0; _i8 < countTotal; _i8++) {
            json['data'][_i8]['id'] = json['data'][_i8]['schedId']; //                    $json['data'][i]['schedId']=$json['schedId'];
          }

          return {
            data: json['data'],
            total: countTotal //parseInt(headers.get('content-range').split('/').pop(), 10)

          };
        } else if (json['campaign'].length > 0) {
          json['data'] = json['campaign'];
          return {
            data: json['data']
          };
        }

        if (!headers.has('content-range')) {
          throw new Error('The Content-Range header is missing in the HTTP Response. The simple REST data provider expects responses for lists of resources to contain this header with the total number of results to build the pagination. If you are using CORS, did you declare Content-Range in the Access-Control-Expose-Headers header?');
        }

        return {
          data: json,
          total: parseInt(headers.get('content-range').split('/').pop(), 10)
        };

      case react_admin_1.GET_ONE:
        switch (resource) {
          case 'Templates':
            var countTotal = json['templates'].length;

            for (var _i9 = 0; _i9 < countTotal; _i9++) {
              if (json['templates'][_i9]['templateId'] == params.id) var newjson = json['templates'][_i9];
            }

            newjson.id = params.id;
            return {
              data: newjson
            };

          case 'Profile':
            json.id = 1;
            return {
              data: json
            };

          case 'EshopSettings':
            // json.id = 1;
            var jsondata = JSON.parse(json.files[0].contents);
            return {
              data: jsondata
            };

          case 'GetFiles':
            json.id = 1;
            return {
              data: json
            };
        }

      case react_admin_1.CREATE:
        if (resource === 'CreateTemplate') sessionStorage.setItem('NewCampaign', json.templateId);
        return {
          data: __assign({}, params.data, {
            id: json.id
          })
        };

      default:
        if (resource == 'Profile') json.id = 1;
        return {
          data: json
        };
    }
  };
  /**
   * @param {string} type Request type, e.g GET_LIST
   * @param {string} resource Resource name, e.g. "posts"
   * @param {Object} payload Request parameters. Depends on the request type
   * @returns {Promise} the Promise for a data response
   */


  return function (type, resource, params) {
    var token = sessionStorage.getItem('token'); // simple-rest doesn't handle filters on UPDATE route, so we fallback to calling UPDATE n times instead

    if (type === react_admin_1.UPDATE_MANY) {
      return Promise.all(params.ids.map(function (id) {
        return httpClient(apiUrl + "/" + resource + "/" + id, {
          method: 'PUT',
          body: JSON.stringify(params.data)
        });
      })).then(function (responses) {
        return {
          data: responses.map(function (response) {
            return response.json;
          })
        };
      });
    } // simple-rest doesn't handle filters on DELETE route, so we fallback to calling DELETE n times instead


    if (type === react_admin_1.DELETE_MANY) {
      return Promise.all(params.ids.map(function (id) {
        switch (resource) {
          case 'Templates':
            var url = apiUrl + '/DeleteTemplate?token=' + token + '&templateId=' + id;
            var method = 'GET';
            break;

          case 'ScheduledCampaigns':
            var url = apiUrl + '/DeleteScheduledCampaign?token=' + token + '&schedId=' + id;
            var method = 'GET';
            break;

          case 'products':
            var url = apiUrl + '/FileAction?token=' + token + '&what=ivr2:eshop/products/products' + params.previousData.reference + '.json&action=delete';
            var method = 'GET';
            break;

          case 'orders':
          case 'customers':
          case 'categories':
          case 'reviews':
          case 'invoices':
            if (resource == 'invoices') resource = 'orders';
            var url = apiUrl + '/FileAction?token=' + token + '&what=ivr2:eshop/' + resource + '/' + id + '.json&action=delete';
            var method = 'GET';
            break;

          default:
            var url = apiUrl + "/" + resource + "/" + id;
            var method = 'DELETE';
        }

        return httpClient(url, {
          method: method
        });
      })).then(function (responses) {
        return {
          data: responses.map(function (response) {
            return response.json;
          })
        };
      });
    }

    var _a = convertDataRequestToHTTP(type, resource, params),
        url = _a.url,
        options = _a.options;

    return httpClient(url, options).then(function (response) {
      if (resource == 'products' && type == 'CREATE') {
        var request = new Request('http://localhost/ym/api/UploadTextFile?token=' + token + '&what=ivr2:eshop/recordings/' + params.data.reference + '.tts&contents=' + params.data.name);
        return fetch(request).then(function (resp) {
          console.log(resp);
        });
      }

      return convertHTTPResponse(response, type, resource, params);
    });
  };
};